export function isAdmin(): boolean {
    return localStorage.getItem("is_admin") === "true";
}
